"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConditionGB = exports.ConditionNumber = exports.Segments = void 0;
var Segments;
(function (Segments) {
    Segments["ok"] = "ok";
    Segments["soonFull"] = "soonFull";
    Segments["almostFull"] = "almostFull";
    Segments["full"] = "full";
    Segments["overflow"] = "overflow";
})(Segments = exports.Segments || (exports.Segments = {}));
var ConditionNumber;
(function (ConditionNumber) {
    ConditionNumber[ConditionNumber["soonFull"] = 50] = "soonFull";
    ConditionNumber[ConditionNumber["almostFull"] = 80] = "almostFull";
    ConditionNumber[ConditionNumber["full"] = 100] = "full";
})(ConditionNumber = exports.ConditionNumber || (exports.ConditionNumber = {}));
var ConditionGB;
(function (ConditionGB) {
    ConditionGB[ConditionGB["gb50"] = 50] = "gb50";
    ConditionGB[ConditionGB["gb10"] = 10] = "gb10";
})(ConditionGB = exports.ConditionGB || (exports.ConditionGB = {}));
//# sourceMappingURL=quota.js.map